import { useTranslation } from "react-i18next";

const DataSellCoins = () => {
    const { t } = useTranslation();

    return [
        {
            id: 1,
            title: t('SELL_YOUR_COINS_SAFELY'),
            text: t('SECURE_SELLING_EXPERIENCE')
        },
        {
            id: 2,
            title: t('RELIABLE_PAYOUTS'),
            text: t('PAYMENT_TIMELINE')
        },
        {
            id: 3,
            title: t('PRIVACY_PROTECTION'),
            text: t('PROTECT_PERSONAL_INFO')
        },
        {
            id: 4,
            title: t('TRUSTED_BY_SELLERS'),
            text: t('FAIR_PRICES_SUPPORT')
        },
    ];
};

export default DataSellCoins;
